import { URLS } from 'common/constants';
import { changeRoute } from 'common/utils';

export const itemNotPublishedInBranchModal = (updateModal, t): void => {
  updateModal({
    isOpen: true,
    showCloseIcon: true,
    description: t('itemNotPublishedInBranch.description'),
    confirmButtonText: t('itemNotPublishedInBranch.confirm'),
    onConfirm: () => changeRoute(URLS.SHOPPING_CART),
    onClose: () => updateModal({ isOpen: false }),
  });
};
